import { MenuItem, Select } from '@mui/material'
import { Controller, useFormContext } from 'react-hook-form'

const GrandPrizeTypes = ['GrandPrizeOnly', 'GrandPrizeWithLocation']

export const GrandPrizeTypeSelect = (style?: {
  style?: React.CSSProperties
}) => {
  const {
    control,
    formState: { defaultValues },
  } = useFormContext()

  return (
    <Controller
      render={({ field }) => (
        <Select
          {...field}
          style={style?.style}
          labelId="Sweepstake.grandPrizeType"
          variant="outlined"
          fullWidth
          id="Sweepstake.grandPrizeType"
        >
          {GrandPrizeTypes.map((type) => (
            <MenuItem value={type} key={type}>
              {type.replace(/([A-Z])/g, ' $1').replace(/^ +/, '')}
            </MenuItem>
          ))}
        </Select>
      )}
      name="Sweepstake.grandPrizeType"
      control={control}
      defaultValue={defaultValues?.Sweepstake.grandPrizeType}
    />
  )
}
